import { render, staticRenderFns } from "./LogoOverlay.vue?vue&type=template&id=b4929f90&scoped=true"
import script from "./LogoOverlay.vue?vue&type=script&lang=ts"
export * from "./LogoOverlay.vue?vue&type=script&lang=ts"
import style0 from "./LogoOverlay.vue?vue&type=style&index=0&id=b4929f90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4929f90",
  null
  
)

export default component.exports